import { message as staticMessage } from 'antd';

type MessageApi = Pick<typeof staticMessage, 'success' | 'error' | 'warning' | 'info' | 'loading'>;

let activeMessage: MessageApi = staticMessage;

export function setMessageApi(messageApi: MessageApi): void {
  activeMessage = messageApi;
}

export const message: MessageApi = {
  success: (...args) => activeMessage.success(...args),
  error: (...args) => activeMessage.error(...args),
  warning: (...args) => activeMessage.warning(...args),
  info: (...args) => activeMessage.info(...args),
  loading: (...args) => activeMessage.loading(...args),
};
